import React from 'react';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import LockIcon from '@material-ui/icons/Lock';
import LockOpenIcon from '@material-ui/icons/LockOpen';
import SecurityIcon from '@material-ui/icons/Security';
import WarningIcon from '@material-ui/icons/Warning';
import useStyles from './styles';
import { HardwareStatusVariant } from '../../types/hardwareStatus';

export type DeviceStatusIcon = 'device' | 'lock' | 'unlock' | 'warning' | 'unknown';

type Props = {
  label: string;
  variant?: HardwareStatusVariant;
  icon?: DeviceStatusIcon;
};

const variantStyles: {
  [key in HardwareStatusVariant]: {
    backgroundColor: string;
    borderColor: string;
    color: string;
  };
} = {
  success: {
    backgroundColor: '#EAF8F1',
    borderColor: '#B7E4CE',
    color: '#037A56'
  },
  warning: {
    backgroundColor: '#FFF7E6',
    borderColor: '#F4CF87',
    color: '#A35D00'
  },
  danger: {
    backgroundColor: '#FDECEC',
    borderColor: '#F4B8B8',
    color: '#C62828'
  },
  neutral: {
    backgroundColor: '#F3F4F6',
    borderColor: '#D1D5DB',
    color: '#4B5563'
  },
  info: {
    backgroundColor: '#EAF2FF',
    borderColor: '#BFD4F8',
    color: '#2558A8'
  }
};

const renderIcon = (icon: DeviceStatusIcon, className: string) => {
  switch (icon) {
    case 'lock':
      return <LockIcon className={className} />;
    case 'unlock':
      return <LockOpenIcon className={className} />;
    case 'warning':
      return <WarningIcon className={className} />;
    case 'unknown':
      return <HelpOutlineIcon className={className} />;
    case 'device':
      return <SecurityIcon className={className} />;
    default:
      return <CheckCircleIcon className={className} />;
  }
};

const DeviceStatusBadge: React.FC<Props> = ({ label, variant = 'neutral', icon = 'unknown' }: Props) => {
  const classes = useStyles();

  return (
    <span className={classes.badge} style={variantStyles[variant]}>
      {renderIcon(icon, classes.icon)}
      {label}
    </span>
  );
};

export default React.memo(DeviceStatusBadge);
